var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Event } from '@/models/Event';
import PageHeader from '@/components/page-header/PageHeader';
import { DateTime } from 'luxon';
import { blackKidIcons } from '@/support/Icon';
import { Student } from '@/models/Student';
import { hasClass, addClass, getParentWithClass, removeClass } from '@/support/Html';
import { UserSubject, UserSubjectStatusEnum } from '@/models/UserSubject';
import { hex2rgba } from '@/support/String';
import ProgressDialog from '@/components/ProgressDialog/ProgressDialog.vue';
import Chat from '@/components/chat/Chat';
import ErrorHandler from '@/support/ErrorHandler';
import EditSubjectStatusDialog from '@/views/Schedules/EditSubjectStatusDialog';
import UserSubjectMessageForm from '@/components/user-subject-message-form/UserSubjectMessageForm';
import EditDescriptionDialog from '@/views/Schedules/EditDescriptionDialog';
import { User } from '@/models/User';
import { sortByKey } from '@/support/Object';
import LoadFailed from '@/views/Errors/LoadFailed';
import Rating from '@/components/rating/Rating';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import StatusCard from '@/components/status-card/StatusCard';
import ProgressSelect from '@/components/progress-select/ProgressSelect';
import { Template } from '@/models/Template';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import DescriptionColumn from '@/components/DescriptionColumn/DescriptionColumn.vue';
import SubjectDialog from '@/components/SubjectDialog/SubjectDialog.vue';
import { excludeRoles } from '@/support/ExcludeRoles';
import ScoolSnackbar from '@/components/ScoolSnackbar/ScoolSnackbar';
import { RolesEnum } from '@/items/Roles';
import Summary from '@/views/Subjects/Summary';
let ScheduleSubject = class ScheduleSubject extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Schedule Subject';
        this.event = new Event();
        this.isLoading = true;
        this.isRerendering = false;
        this.selected = [];
        this.subjects = [];
        this.students = [];
        this.statuses = [];
        this.newUserSubjects = [];
        this.sortedSubjects = {};
        this.chatUserModel = new User().filter({ roles: [RolesEnum.TEACHER] });
        this.totalSubjects = 0;
        this.userIds = [];
        this.hasSortedSubjects = false;
        this.isEditingTreatment = false;
        this.selectedStudentId = '';
        this.isDisplayingProgressDialog = false;
        this.selectedAll = false;
        this.selectedUsers = [];
        this.intermediateSelect = false;
        this.allSort = {
            inactive: [],
            highlighted: [],
            busy: [],
            old: [],
            closed: [],
            finished: [],
        };
        // Edit Subject Dialog start
        this.templates = [];
        this.subjectTarget = null;
        this.isShowingEditSubjectDialog = false;
        this.subjectDialogStudent = null;
        // Edit Subject Dialog end
        // Subject Dialog start
        this.subjectDialogSubject = null;
        this.isSubjectDialogOpen = false;
        // Subject Dialog end
        this.statusColorMap = {
            highlighted: '#f8c623',
            busy: '#008ac4',
            old: '#ff7800',
            inactive: '#9b9b9b',
            closed: '#d0021b',
            finished: '#00b900',
        };
        this.selectedStatus = '';
        this.isDisplayingStudentNotes = false;
        this.selectedStudent = null;
        this.isShowingStatusDialog = false;
        this.isDisplayingIdpNotesDialog = false;
        this.isDisplayingSubjectDialog = false;
    }
    get studentIds() {
        const ids = [];
        this.students.forEach((student) => {
            ids.push(student.id || '');
        });
        return ids;
    }
    get subjectIds() {
        const ids = [];
        this.subjects.forEach((subject) => {
            ids.push(subject.id || '');
        });
        return ids;
    }
    get hasSelectedStatus() {
        return !!Object.keys(this.sortedSubjects).length;
    }
    get breadcrumbs() {
        return [{ name: this.$tc('schedule.subject'), path: '/schedule_subjects' }, { name: this.event.title || '', path: this.$route.path }];
    }
    get selectedCount() {
        let count = 0;
        this.selectedUsers.forEach((item) => {
            if (item !== null) {
                count += 1;
            }
        });
        return count;
    }
    get selectedStudentRoom() {
        const userId = this.selectedStudent ? this.selectedStudent.id || '' : '';
        if (!userId) {
            return '';
        }
        return this.event.chat['user-' + userId];
    }
    get userSubjectIds() {
        const ids = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            this.statuses.forEach((status) => {
                if (subjectId === status.subject && this.sortedSubjects[subjectId].includes(status.user.toString())) {
                    ids.push(status.id);
                }
            });
        });
        return ids;
    }
    get userSubjectRooms() {
        const rooms = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            this.statuses.forEach((status) => {
                if (subjectId === status.subject && this.sortedSubjects[subjectId].includes(status.user.toString())) {
                    if (status.chat && status.chat.default && status.status === 'highlighted') {
                        rooms.push(status.chat.default);
                    }
                }
            });
        });
        return rooms;
    }
    get selectedSubjectIds() {
        const subjectIds = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            subjectIds.push(subjectId);
        });
        return Array.from(new Set(subjectIds));
    }
    // Subject Dialog End
    get dialogOptionsResetStudentStatuses() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.reset', { item: this.$t('dialogOptions.item.helpAndFinished') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.reset').toString(),
                    action: () => {
                        const subjects = [];
                        const users = [];
                        Object.keys(this.sortedSubjects).forEach((id) => {
                            subjects.push(id);
                        });
                        Object.keys(this.sortedSubjects).forEach((id) => {
                            if (id) {
                                this.sortedSubjects[id].forEach((user) => {
                                    users.push(user);
                                });
                            }
                        });
                        const payload = {
                            users,
                            subjects,
                        };
                        new UserSubject()
                            .bulkUpdateClearStudentStatuses(payload)
                            .then((response) => {
                            this.handleStatusChanged();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                    },
                },
            },
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get snackbarActions() {
        const areSelectedSubjectsBusy = this.selectedUserSubjects.every((subject) => subject.status === UserSubjectStatusEnum.HIGHLIGHTED);
        return [
            {
                icon: 'do_not_disturb_on',
                click: () => { this.emptySelected(); },
                label: this.$t('snackbar.actions.deselect').toString(),
            },
            ...(areSelectedSubjectsBusy ? [{
                    icon: 'edit',
                    click: () => {
                        this.isDisplayingProgressDialog = true;
                    },
                    label: 'Voortgang',
                }] : []),
            {
                icon: 'list',
                click: () => { this.isDisplayingSubjectDialog = true; },
                label: this.$t('snackbar.actions.roadmap').toString(),
            },
            {
                icon: 'nearby_error',
                click: () => {
                    this.onPriorityChange(true);
                },
                label: 'Prio geven',
            },
            {
                icon: 'not_interested',
                click: () => {
                    this.onPriorityChange(false);
                },
                label: 'Prio verwijderen',
            },
            ...this.exclude
                ? []
                : [
                    {
                        icon: 'question_answer',
                        click: () => { this.openIdpNotesDialog(); },
                        label: this.$t('snackbar.actions.chat').toString(),
                    },
                    {
                        icon: 'error_outline',
                        click: () => { this.$store.dispatch('openDialog', this.dialogOptionsResetStudentStatuses); },
                        label: this.$t('snackbar.actions.reset_statuses').toString(),
                    },
                ],
        ];
    }
    get snackbarCount() {
        let count = 0;
        Object.entries(this.sortedSubjects).forEach(([key, value]) => {
            count += value.length;
        });
        return count;
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        new Event()
            .include(['chat', 'room', 'subject', 'subjects', 'parent', 'meta', 'users', 'roles', 'datetimeslots', 'treatment', 'treatment_labels'])
            .filter({ role: RolesEnum.STUDENT, is_chosen: true })
            .find(this.$route.params.id)
            .then((event) => {
            this.event = event;
            const students = new Student().dataToModel({}, 'Student', event.users.sort(sortByKey('name')));
            const tempStudents = [];
            students.forEach((student, index) => {
                if (student.filters.role === RolesEnum.STUDENT) {
                    tempStudents.push(student);
                }
            });
            this.students = tempStudents;
            this.subjects = new Student().dataToModel({}, 'Subject', event.subjects);
            this.students.forEach((student, index) => {
                if (student.hasRole([RolesEnum.STUDENT])) {
                    this.$set(this.selectedUsers, index, null);
                }
            });
            if (this.students.length > 0) {
                // this.fetchUserSubjects();
                this.isLoading = false;
            }
            else {
                this.isLoading = false;
            }
        });
    }
    fetchUserSubjects() {
        if (this.students.length <= 0) {
            return;
        }
        this.isLoading = true;
        new UserSubject()
            .include(['chat', 'parent', 'is_linked_to_project'])
            .limit(1000)
            .user(this.students[0])
            .filter({ users: this.studentIds, subjects: this.subjectIds })
            .all()
            .then((statuses) => {
            this.handleUserSubjectSummary(statuses);
            this.addMenuListener();
        });
    }
    handleUserSubjectSummary(statuses) {
        this.isLoading = true;
        this.statuses = statuses;
        const students = this.students;
        students.forEach((student, studentIndex) => {
            student.url = typeof student.url != 'string' ? student.url() : student.url;
            this.students[studentIndex].subjects = {};
            this.subjects.forEach((subject) => {
                const status = this.getStudentStatus(subject, student, false);
                students[studentIndex].subjects[subject.id] = {
                    statusPillCellStyles: this.getStatusPillCellStyles(subject, student),
                    statusPillCellHighlightedStyles: this.getStatusPillCellStyles(subject, student, true),
                    statusPillStyles: this.getStatusPillStyles(subject, student),
                    statusTranslated: this.getStudentStatus(subject, student, true),
                    status,
                    isLinkedToProject: this.getStudentProject(subject, student),
                    isFinished: status === 'finished',
                    rating: this.getSubjectRating(subject, student),
                    description: this.getStudentDescription(subject, student),
                    has_requested_help: this.getStudentHasRequestedHelp(subject, student),
                    is_marked_as_finished_by_student: this.getMarkedAsFinishedByStudent(subject, student),
                    has_priority: this.getStudentHasPriority(subject, student),
                    progress: this.getSubjectProgress(subject, student),
                };
            });
        });
        this.students = students;
        this.isLoading = false;
    }
    onClickSideScrollSummaryTable(direction) {
        const scrollableContainer = document.querySelector('.goalsummaryTableContainer');
        if (!scrollableContainer) {
            return;
        }
        this.sideScrollSummaryTable(scrollableContainer, direction);
    }
    sideScrollSummaryTable(element, direction) {
        // 262.5 is the width of a table column.
        const amountToScroll = 262.5 * 1;
        element.scrollBy({
            left: direction === 'left' ? -Math.abs(amountToScroll) : amountToScroll,
            behavior: 'smooth',
        });
    }
    getSubjectProgress(subject, user) {
        let progress = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                progress = userSubject.progress;
            }
        });
        return progress;
    }
    getStudentHasPriority(subject, user) {
        let has_priority;
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                has_priority = userSubject.has_priority;
            }
        });
        return has_priority === undefined ? false : has_priority;
    }
    addMenuListener() {
        document.addEventListener('click', (event) => {
            this.hideUserMenu(event);
        });
    }
    async onProgressChanged(progress) {
        const promiseArray = [];
        const test = Object.keys(this.sortedSubjects)
            .forEach((subjectId) => this.sortedSubjects[subjectId]
            .forEach((userId) => {
            const user = new UserSubject()
                .user(userId)
                .put([{ subject: subjectId, progress }]);
            promiseArray.push(user);
        }));
        Promise.all(promiseArray).then(this.handleStatusChanged);
    }
    showFullDescription(event) {
        const target = event.target;
        if (hasClass(target, 'descriptionPopout')) {
            return;
        }
        const td = target;
        const popout = target.querySelectorAll('.descriptionPopout')[0];
        addClass(popout, 'show');
    }
    hideFullDescription(event, closeClick = false) {
        const target = event.target;
        let popout;
        if (closeClick) {
            popout = getParentWithClass(target, 'descriptionPopout');
        }
        else {
            popout = target.querySelectorAll('.descriptionPopout')[0];
        }
        if (popout !== null) {
            removeClass(popout, 'show');
        }
    }
    hideUserMenu(event) {
        if (event !== undefined) {
            const target = event.target;
            if (hasClass(target, 'userMenubutton') || hasClass(target, 'userMenu') || hasClass(target, 'userMenu__item')) {
                return;
            }
        }
        if (document.querySelectorAll('.userMenu.show')[0]) {
            const activeMenu = document.querySelectorAll('.userMenu.show')[0];
            removeClass(activeMenu, 'show');
        }
    }
    showUserMenu(event) {
        const target = event.target;
        const activeButton = document.querySelectorAll('.userMenu.show')[0];
        if (activeButton) {
            removeClass(activeButton, 'show');
        }
        const menu = target.querySelectorAll('.userMenu')[0];
        addClass(menu, 'show');
    }
    date(key) {
        return DateTime.fromSQL(this.event[key]);
    }
    icon(key) {
        key = key || 'others';
        return blackKidIcons[key];
    }
    getStudentStatus(subject, user, translate = false) {
        let status = 'inactive';
        if (this.statuses.length === 0) {
            return status;
        }
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                status = userSubject.status || '';
            }
        });
        if (translate && status.length > 0) {
            return this.subjectStatusLabel(status);
        }
        return status;
    }
    getSubjectRating(subject, user) {
        let rating;
        if (this.statuses.length === 0) {
            return status;
        }
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                rating = userSubject.rating;
            }
        });
        return rating;
    }
    getSubjectStatusCount(subject) {
        const totals = {
            highlighted: 0,
            busy: 0,
            old: 0,
            inactive: this.students.length,
            closed: 0,
            finished: 0,
            future: 0,
        };
        this.statuses.forEach((userSubject, index) => {
            if (userSubject.subject !== subject.id) {
                return;
            }
            if (totals[userSubject.status || ''] !== undefined) {
                totals.inactive -= 1;
                totals[userSubject.status] += 1;
            }
        });
        return totals;
    }
    changedSelectedAll(status) {
        this.selectedUsers.forEach((item, index) => {
            this.$set(this.selectedUsers, index, status ? this.students[index].id : null);
        });
    }
    selectedUsersChanged(selection) {
        const count = this.selectedCount;
        if (count === 0) {
            this.selectedAll = false;
        }
        this.intermediateSelect = count !== selection.length && count > 0;
    }
    setAllSort(id, status) {
        const index = this.allSort[status].findIndex((subjectId) => {
            return subjectId === id;
        });
        if (index >= 0) {
            this.allSort[status].splice(index, 1);
        }
        else {
            this.allSort[status].push(id);
        }
    }
    isAllSorted(id, status) {
        return this.allSort[status].includes(id);
    }
    clearSortedSubjects(subjectId, status) {
        const users = this.sortedSubjects[subjectId];
        if (this.sortedSubjects[subjectId]) {
            const userSubjects = status !== 'inactive' ?
                this.pluckStudentBySubjectStatus(subjectId, status) :
                this.pluckStudentsWithInactiveSubject(subjectId, status);
            const clearedSortedSubjects = this.sortedSubjects[subjectId].filter((id) => {
                return !userSubjects.includes(id);
            });
            this.$set(this.sortedSubjects, subjectId, clearedSortedSubjects);
            if (!clearedSortedSubjects.length) {
                users.forEach((studentId) => {
                    this.setCellNeutral(subjectId, studentId);
                });
                delete this.sortedSubjects[subjectId];
            }
            this.allSort[status] = this.allSort[status].filter((subId) => {
                return subId !== subjectId;
            });
        }
    }
    pluckStudentBySubjectStatus(id, status) {
        return this.statuses
            .filter((userSubject) => {
            return userSubject.subject === id && userSubject.status === status;
        })
            .map((user) => {
            return user.user;
        });
    }
    pluckStudentsWithInactiveSubject(id, status) {
        const studentsWithSubject = this.statuses.filter((userSubject) => {
            return userSubject.subject === id;
        });
        return this.students
            .filter((student) => {
            if (studentsWithSubject.findIndex((studentWithSubject) => {
                return studentWithSubject.user === student.id;
            }) < 0) {
                return true;
            }
            return false;
        })
            .map((user) => {
            return user.id;
        });
    }
    sortSummary(subjectId, status) {
        if (this.isAllSorted(subjectId, status)) {
            this.clearSortedSubjects(subjectId, status);
            return;
        }
        let subjectStatusses = this.sortedSubjects[subjectId] || [];
        let students = [];
        if (status !== 'inactive') {
            students = this.pluckStudentBySubjectStatus(subjectId, status);
        }
        else {
            students = this.pluckStudentsWithInactiveSubject(subjectId, status);
            students.forEach((studentId) => {
                const index = this.newUserSubjects.findIndex((newUserSubject) => {
                    return newUserSubject.subject === subjectId && newUserSubject.user === studentId;
                });
                if (index < 0) {
                    this.newUserSubjects.push({ subject: subjectId, user: studentId });
                }
            });
        }
        this.setAllSort(subjectId, status);
        subjectStatusses = [...new Set([...subjectStatusses, ...students])];
        students.forEach((studentId) => {
            this.setCellHighlighted(subjectId, studentId);
        });
        this.$set(this.sortedSubjects, subjectId, subjectStatusses);
        this.userIds = this.sortedSubjects[subjectId] || [];
    }
    userStatusClasses(subject, student) {
        const sorted = this.sortedSubjects;
        const status = this.getStudentStatus(subject, student);
        const classes = [`statusPillCell--${status}`];
        if (subject.id && sorted[subject.id] && sorted[subject.id].includes(status)) {
            classes.push('active');
        }
        return classes;
    }
    selectItem(value) { }
    select(event) {
        // subject, student,
        let target = event.target;
        if (event.target && (!target.hasAttribute('data-subject') || !target.hasAttribute('data-student'))) {
            target = target.parentElement;
            if (event.target && (!target.hasAttribute('data-subject') || !target.hasAttribute('data-student'))) {
                event.preventDefault();
                return;
            }
        }
        const subject = this.findSubjectById(target.getAttribute('data-subject'));
        const student = this.findStudentById(target.getAttribute('data-student'));
        if (!subject || !subject.id || !student || !student.id) {
            return;
        }
        if (this.getStudentStatus(subject, student) === 'inactive') {
            this.setNewUserSubject(subject, student);
        }
        const subjectStatusses = this.sortedSubjects[subject.id] || [];
        if (subjectStatusses.includes(student.id)) {
            const index = subjectStatusses.findIndex((item) => {
                return item === student.id;
            });
            target.style.backgroundColor = student.subjects[subject.id].statusPillCellStyles.backgroundColor;
            subjectStatusses.splice(index, 1);
        }
        else {
            target.style.backgroundColor = student.subjects[subject.id].statusPillCellHighlightedStyles.backgroundColor;
            subjectStatusses.push(student.id);
        }
        if (subjectStatusses.length) {
            this.$set(this.sortedSubjects, subject.id, subjectStatusses);
        }
        else {
            delete this.sortedSubjects[subject.id];
        }
        this.userIds = this.sortedSubjects[subject.id] || [];
    }
    setNewUserSubject(subject, student) {
        if (!subject.id || !student.id) {
            return;
        }
        const index = this.newUserSubjects.findIndex((newUserSubject) => {
            return newUserSubject.subject === subject.id && newUserSubject.user === student.id;
        });
        if (index < 0) {
            this.newUserSubjects.push({ subject: subject.id, user: student.id });
        }
        else {
            this.newUserSubjects.splice(index, 1);
        }
    }
    getStatusPillCellStyles(subject, student, highlighted = false) {
        const sorted = this.sortedSubjects;
        const status = this.getStudentStatus(subject, student);
        const color = this.statusColorMap[status] || '#000';
        if (highlighted || (subject.id && sorted[subject.id] && sorted[subject.id].includes(student.id))) {
            const lightColor = status === 'highlighted' ? hex2rgba(color, 0.4) : hex2rgba(color, 0.2);
            return { backgroundColor: `${lightColor}` };
        }
        return { backgroundColor: `#FFFFFF` };
    }
    getStatusPillStyles(subject, student) {
        const status = this.getStudentStatus(subject, student, false);
        const color = this.statusColorMap[status] || '#000';
        return { backgroundColor: `${color}` };
    }
    tableScroll(event) {
        const target = event.target;
        const scrollPosLeft = target.scrollLeft;
        const scrollPosTop = target.scrollTop;
        const fixedTable = document.getElementsByClassName('goalsummaryTable--fixed')[0];
        const fixedHeader = document.getElementsByClassName('goalsummaryTable--fixedheading')[0];
        if (scrollPosLeft > 1) {
            addClass(fixedTable, 'show');
            fixedTable.style.left = scrollPosLeft + 'px';
            if (document.querySelectorAll('.userMenu--full.show')[0]) {
                const activeMenu = document.querySelectorAll('.userMenu--full.show')[0];
                removeClass(activeMenu, 'show');
            }
        }
        else {
            removeClass(fixedTable, 'show');
            if (document.querySelectorAll('.userMenu--fixed.show')[0]) {
                const activeMenu = document.querySelectorAll('.userMenu--fixed.show')[0];
                removeClass(activeMenu, 'show');
            }
        }
        if (scrollPosTop > 240) {
            addClass(fixedHeader, 'show');
            fixedHeader.style.top = scrollPosTop + 'px';
        }
        else {
            removeClass(fixedHeader, 'show');
        }
    }
    emptySelected() {
        this.selectedAll = false;
        this.selected = [];
        this.sortedSubjects = {};
        this.newUserSubjects = [];
        this.selectedUsers = [];
        this.totalSubjects = 0;
        this.clearAllSort();
        this.clearPillCellStyles();
        this.rerender();
    }
    parseSortedSubjects() {
        const sortedStudents = {};
        Object.keys(this.sortedSubjects).forEach((id) => {
            const students = this.sortedSubjects[id];
            students.forEach((student) => {
                if (!sortedStudents[student]) {
                    sortedStudents[student] = [id];
                }
                else {
                    sortedStudents[student].push(id);
                }
            });
        });
        return sortedStudents;
    }
    showStatusDialog() {
        this.isShowingStatusDialog = true;
    }
    openIdpNotesDialog() {
        this.isDisplayingIdpNotesDialog = true;
    }
    handleStatusChanged() {
        this.emptySelected();
        this.fetchUserSubjects();
    }
    isSelectedUser(userId) {
        return this.selectedUsers.includes(userId);
    }
    isSelectedSubject(subjectId) {
        return Object.keys(this.sortedSubjects).includes(subjectId);
    }
    findSubjectById(id) {
        return this.subjects.find((subject) => {
            return subject.id === id;
        });
    }
    findStudentById(id) {
        return this.students.find((student) => {
            return student.id === id;
        });
    }
    rerender() {
        this.isRerendering = true;
        this.$nextTick(() => {
            this.isRerendering = false;
        });
    }
    get selectedUserSubjects() {
        const selectedSubjects = [];
        Object.keys(this.sortedSubjects)
            .forEach((key) => this.sortedSubjects[key]
            .forEach((userId) => {
            const student = this.findStudentById(userId);
            if (student
                && (student.subjects)
                && student.subjects[key]) {
                selectedSubjects.push(student.subjects[key]);
            }
        }));
        return selectedSubjects;
    }
    getQuerySelector(subjectId, studentId) {
        let query = `[data-subject="${subjectId}"]`;
        if (studentId) {
            query = `${query}[data-student="${studentId}"]`;
        }
        return query;
    }
    findCellById(subjectId, studentId) {
        const query = this.getQuerySelector(subjectId, studentId);
        return document.querySelector(query);
    }
    setCellState(subjectId, studentId, isHighlighted) {
        const pillCell = this.findCellById(subjectId, studentId);
        if (!pillCell) {
            return;
        }
        let cellStyle = { backgroundColor: '#FFF' };
        if (studentId) {
            const student = this.findStudentById(studentId);
            cellStyle = isHighlighted ? student.subjects[subjectId].statusPillCellHighlightedStyles : student.subjects[subjectId].statusPillCellStyles;
        }
        pillCell.style.backgroundColor = cellStyle.backgroundColor;
    }
    setCellNeutral(subjectId, studentId) {
        this.setCellState(subjectId, studentId, false);
    }
    setCellHighlighted(subjectId, studentId) {
        this.setCellState(subjectId, studentId, true);
    }
    // Edit Subject Dialog Start
    async showEditSubjectDialog(subjectId, student, ignoreStatusCheck = false) {
        if (!subjectId || !student) {
            return;
        }
        this.subjectDialogStudent = student;
        await this.fetchUserSubject(subjectId, student.id ? student.id : '');
        if (['dismissed', 'future'].includes(this.subjectTarget && this.subjectTarget.status || '') && !ignoreStatusCheck) {
            return;
        }
        if (!this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            this.getTemplates(subjectId);
        }
        this.isShowingEditSubjectDialog = true;
    }
    async fetchUserSubject(subjectId, studentId) {
        try {
            this.subjectTarget = await new UserSubject()
                .user(studentId || '')
                .include(['finished_user', 'available_at_period', 'added_by_user'])
                .filter({ subjects: [subjectId] })
                .first();
        }
        catch (error) {
            //
        }
    }
    async getTemplates(subjectId) {
        try {
            this.templates = await new Template()
                .subject(subjectId)
                .include('file')
                .all();
        }
        catch (error) {
            //
        }
    }
    canShowEditSubjectDialog(status) {
        if (status === 'inactive' || status === 'future') {
            return false;
        }
        return true;
    }
    async onStatusChanged(status, isDefault) {
        this.selectedStatus = status;
        if (isDefault) {
            this.isShowingStatusDialog = true;
            return;
        }
        await this.update();
        this.handleStatusChanged();
        this.selectedStatus = '';
    }
    async update() {
        const subjects = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            const subjectUsers = this.sortedSubjects[subjectId];
            subjectUsers.forEach((userId) => {
                subjects.push({
                    subject: subjectId,
                    user: userId,
                });
            });
        });
        const payload = {
            subjects,
            status: this.selectedStatus,
        };
        await new UserSubject().bulkUpdate(payload)
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    async onPriorityChange(state) {
        const payloads = [];
        Object.entries(this.sortedSubjects).forEach(([key, values]) => {
            values.map((userId) => {
                payloads.push({
                    userId,
                    subjectId: key,
                    has_priority: state,
                });
            });
        });
        const promises = payloads.map(async (payload) => {
            return await this.updatePriority(payload.userId, payload.subjectId, payload.has_priority);
        });
        await Promise.all(promises);
        this.handleStatusChanged();
    }
    async updatePriority(userId, subjectId, priority) {
        return await new UserSubject().user(userId).putSubject([
            {
                subject: subjectId,
                has_priority: priority,
            },
        ]);
    }
    openTreatmentDialog(studentId) {
        this.selectedStudentId = studentId;
        this.isEditingTreatment = true;
    }
    getStudentProject(subject, user) {
        let isLinkedToProject = false;
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                isLinkedToProject = userSubject.is_linked_to_project;
            }
        });
        return isLinkedToProject;
    }
    getStudentHasRequestedHelp(subject, user) {
        let has_requested_help = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                has_requested_help = userSubject.has_requested_help;
            }
        });
        return has_requested_help === '1' || has_requested_help ? true : false;
    }
    getMarkedAsFinishedByStudent(subject, user) {
        let is_marked_as_finished_by_student = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                is_marked_as_finished_by_student = userSubject.is_marked_as_finished_by_student;
            }
        });
        return is_marked_as_finished_by_student === '1' || is_marked_as_finished_by_student ? true : false;
    }
    getStudentDescription(subject, user) {
        let description = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                description = userSubject.description;
            }
        });
        return description;
    }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    clearAllSort() {
        this.$set(this.allSort, 'busy', []);
        this.$set(this.allSort, 'highlighted', []);
        this.$set(this.allSort, 'closed', []);
        this.$set(this.allSort, 'finished', []);
        this.$set(this.allSort, 'inactive', []);
        this.$set(this.allSort, 'old', []);
    }
    clearPillCellStyles() {
        document.querySelectorAll('.statusPillCell').forEach((element) => {
            element.setAttribute('style', '');
        });
    }
    isShowingStatusDialogChange(isVisible) {
        if (!isVisible) {
            this.emptySelected();
        }
        else {
            this.totalSubjects = this.newUserSubjects.length + this.userSubjectIds.length;
        }
    }
    onStatusDialogChanged(isOpen) {
        if (!isOpen) {
            this.selectedStatus = '';
        }
    }
    // Subject Dialog Start
    onOpenSubjectDialog(subject) {
        if (!subject || !subject.id) {
            return;
        }
        this.subjectDialogSubject = subject;
        this.isSubjectDialogOpen = true;
    }
    onSortedSubjectsChange() {
        this.hasSortedSubjects = Object.keys(this.sortedSubjects).length === 0
            ? false
            : true;
    }
};
__decorate([
    Watch('selectedAll'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ScheduleSubject.prototype, "changedSelectedAll", null);
__decorate([
    Watch('selectedUsers'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ScheduleSubject.prototype, "selectedUsersChanged", null);
__decorate([
    Watch('isShowingStatusDialog'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ScheduleSubject.prototype, "isShowingStatusDialogChange", null);
__decorate([
    Watch('isShowingStatusDialog'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ScheduleSubject.prototype, "onStatusDialogChanged", null);
__decorate([
    Watch('sortedSubjects', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ScheduleSubject.prototype, "onSortedSubjectsChange", null);
ScheduleSubject = __decorate([
    Component({
        components: {
            Chat,
            PageHeader,
            EditSubjectStatusDialog,
            UserSubjectMessageForm,
            EditDescriptionDialog,
            LoadFailed,
            Rating,
            TreatmentDialog,
            StatusCard,
            ProgressSelect,
            EditSubjectDialog,
            DescriptionColumn,
            SubjectDialog,
            ScoolSnackbar,
            ProgressDialog,
            Summary,
        },
    })
], ScheduleSubject);
export default ScheduleSubject;
